export default (size, base = 16) => `${size * base}px`;
